import React from "react";
import Icon from "./Icon";
export default function Plus(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("line", {
    x1: "11",
    y1: "2",
    x2: "11",
    y2: "20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "2",
    y1: "11",
    x2: "20",
    y2: "11"
  }));
}
Plus.displayname = "Plus";
//# sourceMappingURL=Plus.js.map